export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Google Veo 3 Fast AI视频生成器 - 快速高质量AI视频创作工具',
        pageDescription: '体验Google Veo 3 Fast AI视频生成器，快速生成高质量视频内容，支持文本转视频和图像转视频功能。在WeryAI平台免费试用，快速创作专业级AI视频。',
        pageKeywords: 'Veo 3 Fast, Google AI视频生成器, 快速AI视频, AI视频创作, 视频生成工具, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Google Veo 3 Fast视频生成器',
        generatorDescription: 'WeryAI 现已深度集成Veo 3 Fast模型，Veo 3 Fast 是Google Veo 3 视频生成器的<span class="highlight-red">更快、更经济的版本</span>。它可以创建<span class="highlight-red">高质量、逼真的视频</span>，并配有<span class="highlight-red">同步音频</span>，包括对话、环境音效和音乐。现在就来<span class="highlight-red">WeryAI 视频生成器体验一下吧</span>！',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Veo 3 Fast 的主要功能',
        coreFeaturesSubtitle: '探索 Veo 3 Fast 视频生成器的核心功能，享受快速高质量的视频创作体验',

        // 快速生成功能
        fastGenerationTitle: '闪电般快速的视频生成',
        fastGenerationDescription: '比标准 Veo 3 快 30%',

        // 社交媒体功能
        socialMediaTitle: '适用于社交媒体',
        socialMediaDescription: '支持生成可在社交平台上分享的创意内容，例如"假新闻"和"时间旅行"',

        // 沉浸式原生音频功能
        immersiveAudioTitle: '沉浸式原生音频',
        immersiveAudioDescription: '自动生成的音效、对话和环境音',

        // 视频参考和一致的角色功能
        videoReferenceTitle: '视频参考和一致的角色',
        videoReferenceDescription: '根据参考资料生成角色一致的视频',

        // 精确样式控制功能
        styleControlTitle: '精确样式控制',
        styleControlDescription: '根据参考图片控制艺术风格',

        // 相机控制功能
        cameraControlTitle: '相机控制',
        cameraControlDescription: '生成具有特定摄像机移动的视频',

        // 首帧和尾帧功能
        firstLastFrameTitle: '首帧和尾帧',
        firstLastFrameDescription: '生成两张上传图片之间的无缝视频',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，快速开始',
        step1Title: '选择Veo 3 Fast模型',
        step1Description: '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Veo 3 Fast"。',
        step2Title: '输入您的创意内容',
        step2Description: '描述您想要生成的内容，或上传图片进行转换，享受快速生成体验。',
        step3Title: '快速下载您的视频',
        step3Description: '点击"创建"，即可快速获得并下载生成的高质量视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Veo 3 Fast 视频模型的 YouTube 视频',
        youtubeVideosTitle: '关于 Veo 3 Fast 视频模型的 YouTube 视频',
        youtubeVideoTitle: '关于 Veo 3 Fast 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Veo 3 Fast 的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他 Veo 模型',
        veoModelsTitle: 'Google Veo 模型',
        veo2Title: 'Google Veo 2 AI 视频生成器',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        veo3Title: 'Google Veo 3 AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Veo 3 Fast，享受快速高质量的视频生成',
        ctaDescription: '立即体验 Veo 3 Fast，享受快速高质量的视频生成',
        ctaButton: '在 WeryAI 上试用 Veo 3 Fast',
        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle: 'Google Veo 3 Fast AI Video Generator - Fast High-Quality AI Video Creation Tool',
        pageDescription: 'Experience Google Veo 3 Fast AI video generator for rapid high-quality video generation with text-to-video and image-to-video features. Try it free on WeryAI platform and create professional AI videos quickly.',
        pageKeywords: 'Veo 3 Fast, Google AI video generator, fast AI video, AI video creation, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Google Veo 3 Fast Video Generator',
        generatorDescription: 'WeryAI now deeply integrates the Veo 3 Fast model, Veo 3 Fast is a <span class="highlight-red">faster and more economical version</span> of the Google Veo 3 video generator. It can create <span class="highlight-red">high-quality, realistic videos</span> with <span class="highlight-red">synchronized audio</span>, including dialogue, ambient sound effects, and music. <span class="highlight-red">Try it out on the WeryAI video generator now</span>!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Veo 3 Fast Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Veo 3 Fast video generator and enjoy fast, high-quality video creation experience',

        // Fast generation feature
        fastGenerationTitle: 'Lightning Fast Video Generation',
        fastGenerationDescription: '30% faster than standard Veo 3',

        // Social media feature
        socialMediaTitle: 'Perfect for Social Media',
        socialMediaDescription: 'Supports generating creative content for sharing on social platforms, such as "fake news" and "time travel"',

        // Immersive native audio feature
        immersiveAudioTitle: 'Immersive Native Audio',
        immersiveAudioDescription: 'Automatically generated sound effects, dialogue, and ambient sounds',

        // Video reference and consistent characters feature
        videoReferenceTitle: 'Video Reference and Consistent Characters',
        videoReferenceDescription: 'Generate character-consistent videos based on reference materials',

        // Precise style control feature
        styleControlTitle: 'Precise Style Control',
        styleControlDescription: 'Control artistic style based on reference images',

        // Camera control feature
        cameraControlTitle: 'Camera Control',
        cameraControlDescription: 'Generate videos with specific camera movements',

        // First and last frame feature
        firstLastFrameTitle: 'First Frame and Last Frame',
        firstLastFrameDescription: 'Generate seamless videos between two uploaded images',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started quickly',
        step1Title: 'Select Veo 3 Fast Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Veo 3 Fast" in the model dropdown menu.',
        step2Title: 'Enter Your Creative Content',
        step2Description: 'Describe the content you want to generate, or upload images for conversion, and enjoy the fast generation experience.',
        step3Title: 'Quickly Download Your Video',
        step3Description: 'Click "Create" to quickly obtain and download your generated high-quality video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Veo 3 Fast Video Model',
        youtubeVideosTitle: 'YouTube Videos About Veo 3 Fast Video Model',
        youtubeVideoTitle: 'YouTube Videos About Veo 3 Fast Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Veo 3 Fast',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Veo Models',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Veo 3 Fast now and enjoy fast, high-quality video generation',
        ctaDescription: 'Experience Veo 3 Fast now and enjoy fast, high-quality video generation',
        ctaButton: 'Try Veo 3 Fast on WeryAI',
        ctaNote: 'No credit card required',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video loading failed',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle: 'Google Veo 3 Fast AI動画ジェネレーター - 高速高品質AI動画作成ツール',
        pageDescription: 'Google Veo 3 Fast AI動画ジェネレーターを体験。高速高品質動画生成、テキストから動画、画像から動画機能をサポート。WeryAIプラットフォームで無料試用し、プロフェッショナルなAI動画を素早く作成。',
        pageKeywords: 'Veo 3 Fast, Google AI動画ジェネレーター, 高速AI動画, AI動画作成, 動画生成ツール, 無料AI動画, WeryAI, 動画制作',

        // ジェネレーター部分
        generatorTitle: 'Google Veo 3 Fast動画ジェネレーター',
        generatorDescription: 'WeryAI はVeo 3 Fastモデルを深く統合し、テキストから動画、画像から動画機能をサポートし、素晴らしい動画コンテンツを素早く作成できます。WeryAI動画ジェネレーターでVeo 3 Fastを無料でお試しください！',
        
        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能部分
        coreFeaturesTitle: 'Veo 3 Fast の主要機能',
        coreFeaturesSubtitle: 'Veo 3 Fast動画ジェネレーターのコア機能を探索し、高速で高品質な動画作成体験をお楽しみください',

        // 高速生成機能
        fastGenerationTitle: '超高速動画生成',
        fastGenerationDescription: '標準のVeo 3より30%速い',

        // ソーシャルメディア機能
        socialMediaTitle: 'ソーシャルメディア向け',
        socialMediaDescription: '「フェイクニュース」や「タイムトラベル」など、ソーシャルプラットフォームで共有できる創造的なコンテンツの生成をサポートします',

        // 没入型ネイティブオーディオ機能
        immersiveAudioTitle: '没入型ネイティブオーディオ',
        immersiveAudioDescription: '自動生成される音響効果、対話、環境音',

        // 動画参照と一貫したキャラクター機能
        videoReferenceTitle: '動画参照と一貫したキャラクター',
        videoReferenceDescription: '参照資料に基づいてキャラクター一貫性のある動画を生成',

        // 精密スタイル制御機能
        styleControlTitle: '精密スタイル制御',
        styleControlDescription: '参照画像に基づいて芸術スタイルを制御',

        // カメラ制御機能
        cameraControlTitle: 'カメラ制御',
        cameraControlDescription: '特定のカメラ移動で動画を生成',

        // 最初と最後のフレーム機能
        firstLastFrameTitle: '最初と最後のフレーム',
        firstLastFrameDescription: '2つのアップロード画像の間のシームレスな動画を生成',

        // 使用方法部分
        howToUseTitle: '使用方法',
        howToUseSubtitle: '簡単3ステップで素早く開始',
        step1Title: 'Veo 3 Fastモデルを選択',
        step1Description: '<span class="highlight-text">「AI動画生成」</span>ページに移動し、モデルドロップダウンメニューで「Veo 3 Fast」をクリックします。',
        step2Title: 'コンテンツを入力',
        step2Description: '生成したい内容を記述するか、画像をアップロードして変換し、高速生成体験をお楽しみください。',
        step3Title: '動画を素早くダウンロード',
        step3Description: '「作成」をクリックすると、生成された高品質動画を素早く取得してダウンロードできます。',

        // YouTube動画部分
        youtubeTitle: 'Veo 3 Fast動画モデルに関するYouTube動画',
        youtubeVideosTitle: 'Veo 3 Fast動画モデルに関するYouTube動画',
        youtubeVideoTitle: 'Veo 3 Fast動画モデルに関するYouTube動画',

        // X投稿部分
        xPostsTitle: 'Veo 3 Fastに関する人気のX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: '他のVeoモデルを探索',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI動画ジェネレーター',
        veo3Title: 'Google Veo 3 AI動画ジェネレーター',
        veo31Title: 'Google Veo 3.1 AI動画ジェネレーター',

        // FAQ部分
        faqTitle: 'よくある質問',

        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaSubtitle: '今すぐVeo 3 Fastを体験し、高速で高品質な動画生成をお楽しみください',
        ctaDescription: '今すぐVeo 3 Fastを体験し、高速で高品質な動画生成をお楽しみください',
        ctaButton: 'WeryAIでVeo 3 Fastを試す',
        ctaNote: 'クレジットカード不要',
        ctaDisclaimer: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoUnsupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle: 'Google Veo 3 Fast AI 비디오 생성기 - 빠른 고품질 AI 비디오 제작 도구',
        pageDescription: 'Google Veo 3 Fast AI 비디오 생성기를 체험하세요. 빠른 고품질 비디오 생성, 텍스트에서 비디오, 이미지에서 비디오 기능을 지원합니다. WeryAI 플랫폼에서 무료로 체험하고 전문적인 AI 비디오를 빠르게 만드세요.',
        pageKeywords: 'Veo 3 Fast, Google AI 비디오 생성기, 빠른 AI 비디오, AI 비디오 제작, 비디오 생성 도구, 무료 AI 비디오, WeryAI, 비디오 제작',

        // 생성기 부분
        generatorTitle: 'Google Veo 3 Fast 비디오 생성기',
        generatorDescription: 'WeryAI는 이제 Veo 3 Fast 모델을 심층 통합하여, 고품질을 유지하면서 생성 속도를 크게 향상시켰습니다. 텍스트에서 비디오, 이미지에서 비디오 기능을 지원하여 놀라운 비디오 콘텐츠를 빠르게 만들 수 있습니다. WeryAI 비디오 생성기에서 Veo 3 Fast를 무료로 체험해보세요!',
        
        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Veo 3 Fast 주요 기능',
        coreFeaturesSubtitle: 'Veo 3 Fast 비디오 생성기의 핵심 기능을 탐색하고 빠르고 고품질의 비디오 제작 경험을 즐기세요',

        // 빠른 생성 기능
        fastGenerationTitle: '번개처럼 빠른 비디오 생성',
        fastGenerationDescription: '표준 Veo 3보다 30% 빠름',

        // 소셜 미디어 기능
        socialMediaTitle: '소셜 미디어에 적합',
        socialMediaDescription: '"가짜 뉴스"와 "시간 여행" 등 소셜 플랫폼에서 공유할 수 있는 창의적인 콘텐츠 생성을 지원합니다',

        // 몰입형 네이티브 오디오 기능
        immersiveAudioTitle: '몰입형 네이티브 오디오',
        immersiveAudioDescription: '자동 생성되는 음향 효과, 대화, 환경음',

        // 비디오 참조 및 일관된 캐릭터 기능
        videoReferenceTitle: '비디오 참조 및 일관된 캐릭터',
        videoReferenceDescription: '참조 자료에 기반하여 캐릭터 일관성 있는 비디오 생성',

        // 정밀 스타일 제어 기능
        styleControlTitle: '정밀 스타일 제어',
        styleControlDescription: '참조 이미지를 기반으로 예술적 스타일 제어',

        // 카메라 제어 기능
        cameraControlTitle: '카메라 제어',
        cameraControlDescription: '특정 카메라 이동을 포함한 비디오 생성',

        // 첫 번째 및 마지막 프레임 기능
        firstLastFrameTitle: '첫 번째 및 마지막 프레임',
        firstLastFrameDescription: '업로드된 두 이미지 사이의 원활한 비디오 생성',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 빠르게 시작',
        step1Title: 'Veo 3 Fast 모델 선택',
        step1Description: '<span class="highlight-text">"AI 비디오 생성"</span> 페이지로 이동한 다음 모델 드롭다운 메뉴에서 "Veo 3 Fast"를 클릭합니다.',
        step2Title: '창의적 콘텐츠 입력',
        step2Description: '생성하고 싶은 내용을 설명하거나 변환을 위해 이미지를 업로드하고 빠른 생성 경험을 즐기세요.',
        step3Title: '비디오 빠르게 다운로드',
        step3Description: '"생성"을 클릭하면 생성된 고품질 비디오를 빠르게 획득하고 다운로드할 수 있습니다.',

        // YouTube 비디오 부분
        youtubeTitle: 'Veo 3 Fast 비디오 모델에 대한 YouTube 비디오',
        youtubeVideosTitle: 'Veo 3 Fast 비디오 모델에 대한 YouTube 비디오',
        youtubeVideoTitle: 'Veo 3 Fast 비디오 모델에 대한 YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'Veo 3 Fast에 대한 인기 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: '다른 Veo 모델 탐색',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI 비디오 생성기',
        veo3Title: 'Google Veo 3 AI 비디오 생성기',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',

        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaSubtitle: '지금 Veo 3 Fast를 체험하고 빠르고 고품질의 비디오 생성을 즐기세요',
        ctaDescription: '지금 Veo 3 Fast를 체험하고 빠르고 고품질의 비디오 생성을 즐기세요',
        ctaButton: 'WeryAI에서 Veo 3 Fast 체험하기',
        ctaNote: '신용카드 불필요',
        ctaDisclaimer: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoUnsupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoLoadError: '비디오 로딩 실패',
        videoReload: '다시 로드',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Google Veo 3 Fast AI视频生成器 - 快速高质量AI视频创作工具',
        pageDescription: '体验Google Veo 3 Fast AI视频生成器，快速生成高质量视频内容，支持文本转视频和图像转视频功能。在WeryAI平台免费试用，快速创作专业级AI视频。',
        pageKeywords: 'Veo 3 Fast, Google AI视频生成器, 快速AI视频, AI视频创作, 视频生成工具, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Google Veo 3 Fast视频生成器',
        generatorDescription: 'WeryAI 現已深度整合Veo 3 Fast模型，Veo 3 Fast 是Google Veo 3 视频生成器的<span class="highlight-red">更快、更经济的版本</span>。它可以创建<span class="highlight-red">高质量、逼真的视频</span>，并配有<span class="highlight-red">同步音频</span>，包括对话、环境音效和音乐。现在就来<span class="highlight-red">WeryAI 视频生成器体验一下吧</span>！',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Veo 3 Fast 的主要功能',
        coreFeaturesSubtitle: '探索 Veo 3 Fast 视频生成器的核心功能，享受快速高质量的视频创作体验',

        // 快速生成功能
        fastGenerationTitle: '闪电般快速的视频生成',
        fastGenerationDescription: '比标准 Veo 3 快 30%',

        // 社交媒体功能
        socialMediaTitle: '适用于社交媒体',
        socialMediaDescription: '支持生成可在社交平台上分享的创意内容，例如"假新闻"和"时间旅行"',

        // 沉浸式原生音频功能
        immersiveAudioTitle: '沉浸式原生音频',
        immersiveAudioDescription: '自动生成的音效、对话和环境音',

        // 视频参考和一致的角色功能
        videoReferenceTitle: '视频参考和一致的角色',
        videoReferenceDescription: '根据参考资料生成角色一致的视频',

        // 精确样式控制功能
        styleControlTitle: '精确样式控制',
        styleControlDescription: '根据参考图片控制艺术风格',

        // 相机控制功能
        cameraControlTitle: '相机控制',
        cameraControlDescription: '生成具有特定摄像机移动的视频',

        // 首帧和尾帧功能
        firstLastFrameTitle: '首帧和尾帧',
        firstLastFrameDescription: '生成两张上传图片之间的无缝视频',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，快速开始',
        step1Title: '选择Veo 3 Fast模型',
        step1Description: '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Veo 3 Fast"。',
        step2Title: '输入您的创意内容',
        step2Description: '描述您想要生成的内容，或上传图片进行转换，享受快速生成体验。',
        step3Title: '快速下载您的视频',
        step3Description: '点击"创建"，即可快速获得并下载生成的高质量视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Veo 3 Fast 视频模型的 YouTube 视频',
        youtubeVideosTitle: '关于 Veo 3 Fast 视频模型的 YouTube 视频',
        youtubeVideoTitle: '关于 Veo 3 Fast 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Veo 3 Fast 的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他 Veo 模型',
        veoModelsTitle: 'Google Veo 模型',
        veo2Title: 'Google Veo 2 AI 视频生成器',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        veo3Title: 'Google Veo 3 AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Veo 3 Fast，享受快速高质量的视频生成',
        ctaDescription: '立即体验 Veo 3 Fast，享受快速高质量的视频生成',
        ctaButton: '在 WeryAI 上试用 Veo 3 Fast',
        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // Page title and description
        pageTitle: 'Google Veo 3 Fast AI Video Generator - Fast High-Quality AI Video Creation Tool',
        pageDescription: 'Experience Google Veo 3 Fast AI video generator for rapid high-quality video generation with text-to-video and image-to-video features. Try it free on WeryAI platform and create professional AI videos quickly.',
        pageKeywords: 'Veo 3 Fast, Google AI video generator, fast AI video, AI video creation, video generation tool, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Google Veo 3 Fast Video Generator',
        generatorDescription: 'WeryAI jest teraz głęboko zintegrowane z modelem Veo 3 Fast, Veo 3 Fast is a <span class="highlight-red">faster and more economical version</span> of the Google Veo 3 video generator. It can create <span class="highlight-red">high-quality, realistic videos</span> with <span class="highlight-red">synchronized audio</span>, including dialogue, ambient sound effects, and music. <span class="highlight-red">Try it out on the WeryAI video generator now</span>!',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Veo 3 Fast Main Features',
        coreFeaturesSubtitle: 'Explore the core features of Veo 3 Fast video generator and enjoy fast, high-quality video creation experience',

        // Fast generation feature
        fastGenerationTitle: 'Lightning Fast Video Generation',
        fastGenerationDescription: '30% faster than standard Veo 3',

        // Social media feature
        socialMediaTitle: 'Perfect for Social Media',
        socialMediaDescription: 'Supports generating creative content for sharing on social platforms, such as "fake news" and "time travel"',

        // Immersive native audio feature
        immersiveAudioTitle: 'Immersive Native Audio',
        immersiveAudioDescription: 'Automatically generated sound effects, dialogue, and ambient sounds',

        // Video reference and consistent characters feature
        videoReferenceTitle: 'Video Reference and Consistent Characters',
        videoReferenceDescription: 'Generate character-consistent videos based on reference materials',

        // Precise style control feature
        styleControlTitle: 'Precise Style Control',
        styleControlDescription: 'Control artistic style based on reference images',

        // Camera control feature
        cameraControlTitle: 'Camera Control',
        cameraControlDescription: 'Generate videos with specific camera movements',

        // First and last frame feature
        firstLastFrameTitle: 'First Frame and Last Frame',
        firstLastFrameDescription: 'Generate seamless videos between two uploaded images',

        // How to use section
        howToUseTitle: 'Jak używać',
        howToUseSubtitle: 'Three simple steps to get started quickly',
        step1Title: 'Select Veo 3 Fast Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Veo 3 Fast" in the model dropdown menu.',
        step2Title: 'Enter Your Creative Content',
        step2Description: 'Describe the content you want to generate, or upload images for conversion, and enjoy the fast generation experience.',
        step3Title: 'Quickly Download Your Video',
        step3Description: 'Click "Create" to quickly obtain and download your generated high-quality video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Veo 3 Fast Video Model',
        youtubeVideosTitle: 'YouTube Videos About Veo 3 Fast Video Model',
        youtubeVideoTitle: 'YouTube Videos About Veo 3 Fast Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Veo 3 Fast',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Veo Models',
        veoModelsTitle: 'Google Veo Models',
        veo2Title: 'Google Veo 2 AI Video Generator',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        veo3Title: 'Google Veo 3 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle: 'Experience Veo 3 Fast now and enjoy fast, high-quality video generation',
        ctaDescription: 'Experience Veo 3 Fast now and enjoy fast, high-quality video generation',
        ctaButton: 'Try Veo 3 Fast on WeryAI',
        ctaNote: 'No credit card required',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video loading failed',
        videoReload: 'Reload',
    },
    es: {
        // Título y descripción de la página
        pageTitle: 'Generador de video IA Google Veo 3 Fast - Herramienta rápida para crear videos IA de alta calidad | WeryAI',
        pageDescription: 'Experimenta el generador de video con IA Google Veo 3 Fast para producir rápidamente videos de alta calidad con funciones de texto a video e imagen a video. Pruébalo gratis en la plataforma WeryAI y crea videos profesionales con IA en poco tiempo.',
        pageKeywords: 'Veo 3 Fast, generador de video IA de Google, video IA rápido, creación de video IA, herramienta de generación de video, video IA gratis, WeryAI, producción de video',

        // Sección del generador
        generatorTitle: 'Generador de video Google Veo 3 Fast',
        generatorDescription: 'WeryAI ahora integra profundamente el modelo Veo 3 Fast, Veo 3 Fast es una <span class="highlight-red">versión más rápida y económica</span> del generador de video Google Veo 3. Puede crear <span class="highlight-red">videos realistas de alta calidad</span> con <span class="highlight-red">audio sincronizado</span>, incluidos diálogos, efectos de ambiente y música. ¡<span class="highlight-red">Pruébalo ahora mismo en el generador de video de WeryAI</span>!',
        
        // Pestañas
        tabImageToVideo: 'Imagen a video',
        tabTextToVideo: 'Texto a video',

        // Funciones principales
        coreFeaturesTitle: 'Funciones principales de Veo 3 Fast',
        coreFeaturesSubtitle: 'Explora las funciones clave del generador de video Veo 3 Fast y disfruta de una experiencia rápida y de alta calidad',

        // Generación rápida
        fastGenerationTitle: 'Generación de video ultrarrápida',
        fastGenerationDescription: '30% más rápido que Veo 3 estándar',

        // Redes sociales
        socialMediaTitle: 'Ideal para redes sociales',
        socialMediaDescription: 'Permite crear contenido creativo para compartir en plataformas sociales, como "fake news" y "viajes en el tiempo"',

        // Audio inmersivo
        immersiveAudioTitle: 'Audio nativo inmersivo',
        immersiveAudioDescription: 'Efectos de sonido, diálogos y ambientes generados automáticamente',

        // Referencias de video
        videoReferenceTitle: 'Referencia de video y personajes consistentes',
        videoReferenceDescription: 'Genera videos con personajes coherentes a partir de materiales de referencia',

        // Control de estilo
        styleControlTitle: 'Control preciso del estilo',
        styleControlDescription: 'Controla el estilo artístico basándote en imágenes de referencia',

        // Control de cámara
        cameraControlTitle: 'Control de cámara',
        cameraControlDescription: 'Genera videos con movimientos de cámara específicos',

        // Primer y último fotograma
        firstLastFrameTitle: 'Primer y último fotograma',
        firstLastFrameDescription: 'Genera videos fluidos entre dos imágenes cargadas',

        // Cómo usar
        howToUseTitle: 'Cómo usarlo',
        howToUseSubtitle: 'Comienza rápido en tres sencillos pasos',
        step1Title: 'Selecciona el modelo Veo 3 Fast',
        step1Description: 'Ve a la página de <span class="highlight-text">"Generación de video con IA"</span> y elige "Veo 3 Fast" en el menú desplegable de modelos.',
        step2Title: 'Introduce tu idea creativa',
        step2Description: 'Describe el contenido que deseas generar o sube imágenes para convertirlas y disfruta de una experiencia de generación veloz.',
        step3Title: 'Descarga tu video rápidamente',
        step3Description: 'Haz clic en "Crear" para obtener y descargar rápidamente tu video de alta calidad.',

        // Videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el modelo de video Veo 3 Fast',
        youtubeVideosTitle: 'Videos de YouTube sobre el modelo de video Veo 3 Fast',
        youtubeVideoTitle: 'Videos de YouTube sobre el modelo de video Veo 3 Fast',

        // Publicaciones en X
        xPostsTitle: 'Publicaciones destacadas en X sobre Veo 3 Fast',

        // Explorar otros modelos
        exploreModelsTitle: 'Explora otros modelos Veo',
        veoModelsTitle: 'Modelos Google Veo',
        veo2Title: 'Generador de video IA Google Veo 2',
        veo31Title: 'Generador de video IA Google Veo 3.1',
        veo3Title: 'Generador de video IA Google Veo 3',

        // Preguntas frecuentes
        faqTitle: 'Preguntas frecuentes',

        // CTA
        ctaTitle: '¿Listo para empezar a crear?',
        ctaSubtitle: 'Experimenta Veo 3 Fast ahora y disfruta de una generación de video rápida y de alta calidad',
        ctaDescription: 'Experimenta Veo 3 Fast ahora y disfruta de una generación de video rápida y de alta calidad',
        ctaButton: 'Probar Veo 3 Fast en WeryAI',
        ctaNote: 'No se requiere tarjeta de crédito',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',

        // Reproducción de video
        videoNotSupported: 'Tu navegador no admite la reproducción de video',
        videoUnsupported: 'Tu navegador no admite la reproducción de video',
        videoLoadingError: 'Fallo al cargar el video',
        videoLoadError: 'Fallo al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle: 'Générateur vidéo IA Google Veo 3 Fast - Outil rapide de création vidéo IA haute qualité | WeryAI',
        pageDescription: 'Découvrez le générateur vidéo IA Google Veo 3 Fast pour produire rapidement des vidéos de haute qualité avec les fonctions texte vers vidéo et image vers vidéo. Essayez-le gratuitement sur la plateforme WeryAI et créez des vidéos IA professionnelles en un rien de temps.',
        pageKeywords: 'Veo 3 Fast, générateur vidéo IA Google, vidéo IA rapide, création vidéo IA, outil de génération vidéo, vidéo IA gratuite, WeryAI, production vidéo',

        // Section du générateur
        generatorTitle: 'Générateur vidéo Google Veo 3 Fast',
        generatorDescription: 'WeryAI intègre désormais en profondeur le modèle Veo 3 Fast, Veo 3 Fast est une <span class="highlight-red">version plus rapide et plus économique</span> du générateur vidéo Google Veo 3. Il crée des <span class="highlight-red">vidéos réalistes de haute qualité</span> avec un <span class="highlight-red">audio synchronisé</span>, incluant dialogues, ambiances et musique. <span class="highlight-red">Testez-le dès maintenant sur le générateur vidéo WeryAI</span> !',
        
        // Onglets
        tabImageToVideo: 'Image vers vidéo',
        tabTextToVideo: 'Texte vers vidéo',

        // Fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités principales de Veo 3 Fast',
        coreFeaturesSubtitle: 'Découvrez les fonctionnalités clés du générateur vidéo Veo 3 Fast et profitez d\'une création vidéo rapide et de haute qualité',

        // Génération rapide
        fastGenerationTitle: 'Génération vidéo ultra-rapide',
        fastGenerationDescription: '30 % plus rapide que Veo 3 standard',

        // Réseaux sociaux
        socialMediaTitle: 'Parfait pour les réseaux sociaux',
        socialMediaDescription: 'Prend en charge la création de contenus créatifs à partager sur les plateformes sociales, comme "fake news" ou "voyage dans le temps"',

        // Audio immersif
        immersiveAudioTitle: 'Audio natif immersif',
        immersiveAudioDescription: 'Effets sonores, dialogues et ambiances générés automatiquement',

        // Références vidéo
        videoReferenceTitle: 'Références vidéo et personnages cohérents',
        videoReferenceDescription: 'Générez des vidéos cohérentes avec les personnages à partir de supports de référence',

        // Contrôle du style
        styleControlTitle: 'Contrôle précis du style',
        styleControlDescription: 'Contrôlez le style artistique à partir d\'images de référence',

        // Contrôle de la caméra
        cameraControlTitle: 'Contrôle de la caméra',
        cameraControlDescription: 'Générez des vidéos avec des mouvements de caméra spécifiques',

        // Premier et dernier cadre
        firstLastFrameTitle: 'Premier et dernier cadre',
        firstLastFrameDescription: 'Créez des vidéos fluides entre deux images importées',

        // Comment utiliser
        howToUseTitle: 'Comment l\'utiliser',
        howToUseSubtitle: 'Démarrez rapidement en trois étapes simples',
        step1Title: 'Sélectionnez le modèle Veo 3 Fast',
        step1Description: 'Accédez à la page <span class="highlight-text">"Génération vidéo IA"</span>, puis choisissez "Veo 3 Fast" dans le menu déroulant des modèles.',
        step2Title: 'Saisissez votre idée créative',
        step2Description: 'Décrivez le contenu que vous souhaitez générer ou importez des images à convertir et profitez d\'une expérience de génération rapide.',
        step3Title: 'Téléchargez rapidement votre vidéo',
        step3Description: 'Cliquez sur "Créer" pour obtenir et télécharger rapidement votre vidéo de haute qualité.',

        // Vidéos YouTube
        youtubeTitle: 'Vidéos YouTube sur le modèle vidéo Veo 3 Fast',
        youtubeVideosTitle: 'Vidéos YouTube sur le modèle vidéo Veo 3 Fast',
        youtubeVideoTitle: 'Vidéos YouTube sur le modèle vidéo Veo 3 Fast',

        // Publications X
        xPostsTitle: 'Posts populaires sur X à propos de Veo 3 Fast',

        // Explorer d'autres modèles
        exploreModelsTitle: 'Découvrez d\'autres modèles Veo',
        veoModelsTitle: 'Modèles Google Veo',
        veo2Title: 'Générateur vidéo IA Google Veo 2',
        veo31Title: 'Générateur vidéo IA Google Veo 3.1',
        veo3Title: 'Générateur vidéo IA Google Veo 3',

        // FAQ
        faqTitle: 'FAQ',

        // CTA
        ctaTitle: 'Prêt à commencer à créer ?',
        ctaSubtitle: 'Testez Veo 3 Fast dès maintenant et profitez d\'une génération vidéo rapide et de haute qualité',
        ctaDescription: 'Testez Veo 3 Fast dès maintenant et profitez d\'une génération vidéo rapide et de haute qualité',
        ctaButton: 'Essayer Veo 3 Fast sur WeryAI',
        ctaNote: 'Aucune carte bancaire requise',
        ctaDisclaimer: 'Aucune carte bancaire requise',

        // Lecture vidéo
        videoNotSupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoUnsupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // Seitenüberschrift und Beschreibung
        pageTitle: 'Google Veo 3 Fast KI-Videogenerator - Schnelles Tool zur hochwertigen KI-Videoproduktion | WeryAI',
        pageDescription: 'Erleben Sie den Google Veo 3 Fast KI-Videogenerator, um hochwertige Videos mit Text-zu-Video- und Bild-zu-Video-Funktionen schnell zu erstellen. Testen Sie ihn kostenlos auf der WeryAI-Plattform und produzieren Sie professionelle KI-Videos im Handumdrehen.',
        pageKeywords: 'Veo 3 Fast, Google KI-Videogenerator, schnelles KI-Video, KI-Videoerstellung, Videogenerierungstool, kostenloses KI-Video, WeryAI, Videoproduktion',

        // Generatorabschnitt
        generatorTitle: 'Google Veo 3 Fast Videogenerator',
        generatorDescription: 'WeryAI integriert jetzt das Modell Veo 3 Fast tiefgreifend, Veo 3 Fast ist eine <span class="highlight-red">schnellere und kostengünstigere Version</span> des Google Veo 3 Videogenerators. Er erzeugt <span class="highlight-red">hochwertige, realistische Videos</span> mit <span class="highlight-red">synchronisiertem Audio</span>, einschließlich Dialogen, Umgebungsgeräuschen und Musik. <span class="highlight-red">Probieren Sie den WeryAI-Videogenerator jetzt aus</span>!',
        
        // Registerkarten
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Hauptfunktionen
        coreFeaturesTitle: 'Hauptfunktionen von Veo 3 Fast',
        coreFeaturesSubtitle: 'Entdecken Sie die Kernfunktionen des Veo 3 Fast Videogenerators und genießen Sie ein schnelles, hochwertiges Produktionserlebnis',

        // Schnelle Generierung
        fastGenerationTitle: 'Blitzschnelle Videogenerierung',
        fastGenerationDescription: '30 % schneller als der Standard-Veo 3',

        // Soziale Medien
        socialMediaTitle: 'Ideal für soziale Medien',
        socialMediaDescription: 'Unterstützt die Erstellung kreativer Inhalte für soziale Plattformen, etwa "Fake News" und "Zeitreisen"',

        // Immersives Audio
        immersiveAudioTitle: 'Immersives natives Audio',
        immersiveAudioDescription: 'Automatisch generierte Soundeffekte, Dialoge und Umgebungsgeräusche',

        // Videoreferenzen
        videoReferenceTitle: 'Video-Referenzen und konsistente Charaktere',
        videoReferenceDescription: 'Erstellt charakterkonsistente Videos auf Basis von Referenzmaterialien',

        // Stilkontrolle
        styleControlTitle: 'Präzise Stilkontrolle',
        styleControlDescription: 'Steuern Sie den künstlerischen Stil anhand von Referenzbildern',

        // Kamerasteuerung
        cameraControlTitle: 'Kamerasteuerung',
        cameraControlDescription: 'Generiert Videos mit spezifischen Kamerafahrten',

        // Erster und letzter Frame
        firstLastFrameTitle: 'Erster und letzter Frame',
        firstLastFrameDescription: 'Erzeugt nahtlose Videos zwischen zwei hochgeladenen Bildern',

        // Verwendung
        howToUseTitle: 'So funktioniert es',
        howToUseSubtitle: 'In drei einfachen Schritten schnell starten',
        step1Title: 'Veo 3 Fast Modell auswählen',
        step1Description: 'Öffnen Sie die Seite <span class="highlight-text">"KI-Videoerstellung"</span> und wählen Sie "Veo 3 Fast" im Modell-Dropdown aus.',
        step2Title: 'Ihre kreative Idee eingeben',
        step2Description: 'Beschreiben Sie das gewünschte Ergebnis oder laden Sie Bilder zur Umwandlung hoch und genießen Sie die schnelle Generierung.',
        step3Title: 'Video schnell herunterladen',
        step3Description: 'Klicken Sie auf "Erstellen", um Ihr hochwertiges Video schnell zu erhalten und herunterzuladen.',

        // YouTube-Videos
        youtubeTitle: 'YouTube-Videos zum Veo 3 Fast Videomodell',
        youtubeVideosTitle: 'YouTube-Videos zum Veo 3 Fast Videomodell',
        youtubeVideoTitle: 'YouTube-Videos zum Veo 3 Fast Videomodell',

        // X-Beiträge
        xPostsTitle: 'Beliebte X-Beiträge über Veo 3 Fast',

        // Weitere Modelle entdecken
        exploreModelsTitle: 'Weitere Veo-Modelle entdecken',
        veoModelsTitle: 'Google Veo Modelle',
        veo2Title: 'Google Veo 2 KI-Videogenerator',
        veo31Title: 'Google Veo 3.1 KI-Videogenerator',
        veo3Title: 'Google Veo 3 KI-Videogenerator',

        // FAQ
        faqTitle: 'Häufig gestellte Fragen',

        // CTA
        ctaTitle: 'Bereit, mit der Erstellung zu beginnen?',
        ctaSubtitle: 'Erleben Sie Veo 3 Fast jetzt und profitieren Sie von schneller, hochwertiger Videogenerierung',
        ctaDescription: 'Erleben Sie Veo 3 Fast jetzt und profitieren Sie von schneller, hochwertiger Videogenerierung',
        ctaButton: 'Veo 3 Fast auf WeryAI testen',
        ctaNote: 'Keine Kreditkarte erforderlich',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',

        // Videowiedergabe
        videoNotSupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoUnsupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoLoadingError: 'Video konnte nicht geladen werden',
        videoLoadError: 'Video konnte nicht geladen werden',
        videoReload: 'Neu laden',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle: 'Генератор видео с ИИ Google Veo 3 Fast — Быстрый инструмент для создания качественных видео с ИИ | WeryAI',
        pageDescription: 'Оцените генератор видео с ИИ Google Veo 3 Fast: создавайте высококачественные ролики за считанные минуты с функциями текст-видео и изображение-видео. Попробуйте бесплатно на платформе WeryAI и создавайте профессиональные ИИ-видео максимально быстро.',
        pageKeywords: 'Veo 3 Fast, генератор видео ИИ Google, быстрое ИИ-видео, создание видео с ИИ, инструмент генерации видео, бесплатное ИИ-видео, WeryAI, видеопроизводство',

        // Раздел генератора
        generatorTitle: 'Генератор видео Google Veo 3 Fast',
        generatorDescription: 'WeryAI теперь глубоко интегрировал модель Veo 3 Fast, Veo 3 Fast — это <span class="highlight-red">более быстрая и доступная версия</span> генератора видео Google Veo 3. Он создаёт <span class="highlight-red">реалистичные видео высокого качества</span> с <span class="highlight-red">синхронизированным аудио</span>, включая диалоги, фоновые эффекты и музыку. <span class="highlight-red">Попробуйте его прямо сейчас в видеогенераторе WeryAI</span>!',
        
        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // Основные функции
        coreFeaturesTitle: 'Основные возможности Veo 3 Fast',
        coreFeaturesSubtitle: 'Изучите ключевые функции видеогенератора Veo 3 Fast и насладитесь быстрым и качественным процессом создания',

        // Быстрая генерация
        fastGenerationTitle: 'Молниеносная генерация видео',
        fastGenerationDescription: 'На 30% быстрее стандартного Veo 3',

        // Социальные сети
        socialMediaTitle: 'Идеален для социальных сетей',
        socialMediaDescription: 'Помогает создавать креативный контент для соцсетей, например "фейковые новости" или "путешествия во времени"',

        // Иммерсивное аудио
        immersiveAudioTitle: 'Иммерсивное родное аудио',
        immersiveAudioDescription: 'Автоматически создаваемые звуковые эффекты, диалоги и фоновые шумы',

        // Видеореференсы
        videoReferenceTitle: 'Видеореференсы и согласованные персонажи',
        videoReferenceDescription: 'Создавайте видеоролики с согласованными персонажами на основе референсных материалов',

        // Контроль стиля
        styleControlTitle: 'Точный контроль стиля',
        styleControlDescription: 'Управляйте художественным стилем с помощью референсных изображений',

        // Управление камерой
        cameraControlTitle: 'Управление камерой',
        cameraControlDescription: 'Генерируйте видео с заданными движениями камеры',

        // Первый и последний кадр
        firstLastFrameTitle: 'Первый и последний кадр',
        firstLastFrameDescription: 'Создавайте плавное видео между двумя загруженными изображениями',

        // Как пользоваться
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Начните всего в три простых шага',
        step1Title: 'Выберите модель Veo 3 Fast',
        step1Description: 'Перейдите на страницу <span class="highlight-text">"Генерация видео с ИИ"</span> и выберите "Veo 3 Fast" в выпадающем списке моделей.',
        step2Title: 'Введите вашу творческую идею',
        step2Description: 'Опишите желаемый контент или загрузите изображения для преобразования и наслаждайтесь быстрой генерацией.',
        step3Title: 'Быстро скачайте своё видео',
        step3Description: 'Нажмите "Создать", чтобы быстро получить и скачать высококачественное видео.',

        // Видео на YouTube
        youtubeTitle: 'Видео на YouTube о модели Veo 3 Fast',
        youtubeVideosTitle: 'Видео на YouTube о модели Veo 3 Fast',
        youtubeVideoTitle: 'Видео на YouTube о модели Veo 3 Fast',

        // Публикации в X
        xPostsTitle: 'Популярные публикации в X о Veo 3 Fast',

        // Другие модели
        exploreModelsTitle: 'Исследуйте другие модели Veo',
        veoModelsTitle: 'Модели Google Veo',
        veo2Title: 'Генератор видео с ИИ Google Veo 2',
        veo31Title: 'Генератор видео с ИИ Google Veo 3.1',
        veo3Title: 'Генератор видео с ИИ Google Veo 3',

        // Часто задаваемые вопросы
        faqTitle: 'Часто задаваемые вопросы',

        // CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaSubtitle: 'Попробуйте Veo 3 Fast уже сейчас и оцените быструю генерацию видео высокого качества',
        ctaDescription: 'Попробуйте Veo 3 Fast уже сейчас и оцените быструю генерацию видео высокого качества',
        ctaButton: 'Попробовать Veo 3 Fast на WeryAI',
        ctaNote: 'Банковская карта не требуется',
        ctaDisclaimer: 'Банковская карта не требуется',

        // Воспроизведение видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoUnsupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadingError: 'Не удалось загрузить видео',
        videoLoadError: 'Не удалось загрузить видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // Título e descrição da página
        pageTitle: 'Gerador de Vídeo IA Google Veo 3 Fast - Ferramenta rápida para criar vídeos IA de alta qualidade | WeryAI',
        pageDescription: 'Experimente o gerador de vídeo com IA Google Veo 3 Fast para produzir rapidamente vídeos de alta qualidade com recursos de texto para vídeo e imagem para vídeo. Teste grátis na plataforma WeryAI e crie vídeos profissionais com IA em minutos.',
        pageKeywords: 'Veo 3 Fast, gerador de vídeo IA Google, vídeo IA rápido, criação de vídeo IA, ferramenta de geração de vídeo, vídeo IA gratuito, WeryAI, produção de vídeo',

        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo Google Veo 3 Fast',
        generatorDescription: 'O WeryAI agora integra profundamente o modelo Veo 3 Fast, Veo 3 Fast é uma <span class="highlight-red">versão mais rápida e econômica</span> do gerador de vídeo Google Veo 3. Ele cria <span class="highlight-red">vídeos realistas de alta qualidade</span> com <span class="highlight-red">áudio sincronizado</span>, incluindo diálogos, efeitos ambientes e música. <span class="highlight-red">Experimente agora mesmo no gerador de vídeo da WeryAI</span>!',
        
        // Abas
        tabImageToVideo: 'Imagem para vídeo',
        tabTextToVideo: 'Texto para vídeo',

        // Recursos principais
        coreFeaturesTitle: 'Principais recursos do Veo 3 Fast',
        coreFeaturesSubtitle: 'Explore os recursos essenciais do gerador de vídeo Veo 3 Fast e aproveite uma experiência rápida e de alta qualidade',

        // Geração rápida
        fastGenerationTitle: 'Geração de vídeo ultrarrápida',
        fastGenerationDescription: '30% mais rápido que o Veo 3 padrão',

        // Redes sociais
        socialMediaTitle: 'Perfeito para redes sociais',
        socialMediaDescription: 'Permite criar conteúdos criativos para compartilhar em plataformas sociais, como "fake news" e "viagem no tempo"',

        // Áudio imersivo
        immersiveAudioTitle: 'Áudio nativo imersivo',
        immersiveAudioDescription: 'Efeitos sonoros, diálogos e ambientes gerados automaticamente',

        // Referências de vídeo
        videoReferenceTitle: 'Referências de vídeo e personagens consistentes',
        videoReferenceDescription: 'Gere vídeos com personagens coerentes a partir de materiais de referência',

        // Controle de estilo
        styleControlTitle: 'Controle preciso de estilo',
        styleControlDescription: 'Controle o estilo artístico com base em imagens de referência',

        // Controle de câmera
        cameraControlTitle: 'Controle de câmera',
        cameraControlDescription: 'Gere vídeos com movimentos específicos de câmera',

        // Quadros inicial e final
        firstLastFrameTitle: 'Quadro inicial e final',
        firstLastFrameDescription: 'Crie vídeos contínuos entre duas imagens enviadas',

        // Como usar
        howToUseTitle: 'Como usar',
        howToUseSubtitle: 'Comece rapidamente em três passos simples',
        step1Title: 'Selecione o modelo Veo 3 Fast',
        step1Description: 'Acesse a página <span class="highlight-text">"Geração de vídeo com IA"</span> e escolha "Veo 3 Fast" no menu suspenso de modelos.',
        step2Title: 'Insira sua ideia criativa',
        step2Description: 'Descreva o conteúdo que deseja gerar ou envie imagens para conversão e aproveite a experiência de geração rápida.',
        step3Title: 'Baixe seu vídeo rapidamente',
        step3Description: 'Clique em "Criar" para receber e baixar rapidamente o vídeo em alta qualidade.',

        // Vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube sobre o modelo Veo 3 Fast',
        youtubeVideosTitle: 'Vídeos do YouTube sobre o modelo Veo 3 Fast',
        youtubeVideoTitle: 'Vídeos do YouTube sobre o modelo Veo 3 Fast',

        // Publicações no X
        xPostsTitle: 'Posts populares no X sobre o Veo 3 Fast',

        // Explorar outros modelos
        exploreModelsTitle: 'Explore outros modelos Veo',
        veoModelsTitle: 'Modelos Google Veo',
        veo2Title: 'Gerador de vídeo IA Google Veo 2',
        veo31Title: 'Gerador de vídeo IA Google Veo 3.1',
        veo3Title: 'Gerador de vídeo IA Google Veo 3',

        // Perguntas frequentes
        faqTitle: 'Perguntas frequentes',

        // CTA
        ctaTitle: 'Pronto para começar a criar?',
        ctaSubtitle: 'Experimente o Veo 3 Fast agora e aproveite a geração rápida de vídeos em alta qualidade',
        ctaDescription: 'Experimente o Veo 3 Fast agora e aproveite a geração rápida de vídeos em alta qualidade',
        ctaButton: 'Experimente o Veo 3 Fast na WeryAI',
        ctaNote: 'Não é necessário cartão de crédito',
        ctaDisclaimer: 'Não é necessário cartão de crédito',

        // Reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoUnsupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadingError: 'Falha ao carregar o vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle: 'Generatore video IA Google Veo 3 Fast - Strumento rapido per creare video IA di alta qualità | WeryAI',
        pageDescription: 'Prova il generatore video con IA Google Veo 3 Fast per realizzare rapidamente video di alta qualità con funzioni testo-in-video e immagine-in-video. Testalo gratis sulla piattaforma WeryAI e crea video IA professionali in pochi minuti.',
        pageKeywords: 'Veo 3 Fast, generatore video IA Google, video IA veloce, creazione video IA, strumento di generazione video, video IA gratuito, WeryAI, produzione video',

        // Sezione del generatore
        generatorTitle: 'Generatore video Google Veo 3 Fast',
        generatorDescription: 'WeryAI integra ora in profondità il modello Veo 3 Fast, Veo 3 Fast è una <span class="highlight-red">versione più veloce ed economica</span> del generatore video Google Veo 3. Può creare <span class="highlight-red">video realistici di alta qualità</span> con <span class="highlight-red">audio sincronizzato</span>, inclusi dialoghi, effetti ambientali e musica. <span class="highlight-red">Provalo subito con il generatore video di WeryAI</span>!',
        
        // Schede
        tabImageToVideo: 'Immagine in video',
        tabTextToVideo: 'Testo in video',

        // Funzioni principali
        coreFeaturesTitle: 'Funzionalità principali di Veo 3 Fast',
        coreFeaturesSubtitle: 'Scopri le funzioni chiave del generatore video Veo 3 Fast e goditi un\'esperienza rapida e di alta qualità',

        // Generazione rapida
        fastGenerationTitle: 'Generazione video fulminea',
        fastGenerationDescription: '30% più veloce di Veo 3 standard',

        // Social media
        socialMediaTitle: 'Perfetto per i social media',
        socialMediaDescription: 'Supporta la creazione di contenuti creativi da condividere sulle piattaforme social, come "fake news" e "viaggi nel tempo"',

        // Audio immersivo
        immersiveAudioTitle: 'Audio nativo immersivo',
        immersiveAudioDescription: 'Effetti sonori, dialoghi e ambienti generati automaticamente',

        // Riferimenti video
        videoReferenceTitle: 'Riferimenti video e personaggi coerenti',
        videoReferenceDescription: 'Genera video con personaggi coerenti basandoti su materiali di riferimento',

        // Controllo dello stile
        styleControlTitle: 'Controllo preciso dello stile',
        styleControlDescription: 'Controlla lo stile artistico usando immagini di riferimento',

        // Controllo della videocamera
        cameraControlTitle: 'Controllo della videocamera',
        cameraControlDescription: 'Genera video con movimenti di camera specifici',

        // Primo e ultimo fotogramma
        firstLastFrameTitle: 'Primo e ultimo fotogramma',
        firstLastFrameDescription: 'Crea video senza interruzioni tra due immagini caricate',

        // Come usare
        howToUseTitle: 'Come si usa',
        howToUseSubtitle: 'Inizia rapidamente in tre semplici passaggi',
        step1Title: 'Seleziona il modello Veo 3 Fast',
        step1Description: 'Vai alla pagina <span class="highlight-text">"Generazione video IA"</span> e scegli "Veo 3 Fast" dal menu a discesa dei modelli.',
        step2Title: 'Inserisci la tua idea creativa',
        step2Description: 'Descrivi il contenuto che desideri generare oppure carica immagini da convertire e approfitta della generazione veloce.',
        step3Title: 'Scarica rapidamente il tuo video',
        step3Description: 'Clicca su "Crea" per ottenere e scaricare velocemente il tuo video di alta qualità.',

        // Video YouTube
        youtubeTitle: 'Video YouTube sul modello video Veo 3 Fast',
        youtubeVideosTitle: 'Video YouTube sul modello video Veo 3 Fast',
        youtubeVideoTitle: 'Video YouTube sul modello video Veo 3 Fast',

        // Post su X
        xPostsTitle: 'Post popolari su X dedicati a Veo 3 Fast',

        // Esplora altri modelli
        exploreModelsTitle: 'Esplora altri modelli Veo',
        veoModelsTitle: 'Modelli Google Veo',
        veo2Title: 'Generatore video IA Google Veo 2',
        veo31Title: 'Generatore video IA Google Veo 3.1',
        veo3Title: 'Generatore video IA Google Veo 3',

        // Domande frequenti
        faqTitle: 'Domande frequenti',

        // CTA
        ctaTitle: 'Pronto a iniziare a creare?',
        ctaSubtitle: 'Prova subito Veo 3 Fast e goditi una generazione video rapida e di alta qualità',
        ctaDescription: 'Prova subito Veo 3 Fast e goditi una generazione video rapida e di alta qualità',
        ctaButton: 'Prova Veo 3 Fast su WeryAI',
        ctaNote: 'Non è richiesta la carta di credito',
        ctaDisclaimer: 'Non è richiesta la carta di credito',

        // Riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoUnsupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadingError: 'Caricamento del video non riuscito',
        videoLoadError: 'Caricamento del video non riuscito',
        videoReload: 'Ricarica',
    },
    ar: {
        // عنوان الصفحة والوصف
        pageTitle: 'مولّد الفيديو بالذكاء الاصطناعي Google Veo 3 Fast - أداة سريعة لإنشاء فيديوهات عالية الجودة بالذكاء الاصطناعي | WeryAI',
        pageDescription: 'اختبر مولّد الفيديو بالذكاء الاصطناعي Google Veo 3 Fast لإنشاء فيديوهات عالية الجودة بسرعة مع دعم التحويل من نص إلى فيديو ومن صورة إلى فيديو. جرّبه مجانًا على منصة WeryAI وابتكر فيديوهات احترافية بالذكاء الاصطناعي في وقت قصير.',
        pageKeywords: 'Veo 3 Fast, مولد فيديو ذكاء اصطناعي من Google, فيديو ذكاء اصطناعي سريع, إنشاء فيديو بالذكاء الاصطناعي, أداة توليد فيديو, فيديو ذكاء اصطناعي مجاني, WeryAI, إنتاج فيديو',

        // قسم المولد
        generatorTitle: 'مولّد فيديو Google Veo 3 Fast',
        generatorDescription: 'يقوم WeryAI الآن بدمج نموذج Veo 3 Fast بعمق، يمكنه إنشاء <span class="highlight-red">فيديوهات واقعية عالية الجودة</span> مع <span class="highlight-red">صوت متزامن</span> يشمل الحوارات والمؤثرات البيئية والموسيقى. <span class="highlight-red">جرّبه الآن على مولد الفيديو من WeryAI</span>!',
        
        // علامات التبويب
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // الميزات الأساسية
        coreFeaturesTitle: 'أهم ميزات Veo 3 Fast',
        coreFeaturesSubtitle: 'استكشف الميزات الجوهرية لمولد الفيديو Veo 3 Fast واستمتع بتجربة إنشاء سريعة وعالية الجودة',

        // التوليد السريع
        fastGenerationTitle: 'توليد فيديو بسرعة خاطفة',
        fastGenerationDescription: 'أسرع بنسبة 30٪ من Veo 3 القياسي',

        // وسائل التواصل الاجتماعي
        socialMediaTitle: 'مثالي لوسائل التواصل الاجتماعي',
        socialMediaDescription: 'يدعم إنشاء محتوى مبتكر لمشاركته على المنصات الاجتماعية مثل "الأخبار الزائفة" و"السفر عبر الزمن"',

        // الصوت الغامر
        immersiveAudioTitle: 'صوت أصلي غامر',
        immersiveAudioDescription: 'مؤثرات صوتية وحوارات وأصوات محيطة يتم إنشاؤها تلقائيًا',

        // مراجع الفيديو
        videoReferenceTitle: 'مراجع فيديو وشخصيات متسقة',
        videoReferenceDescription: 'أنشئ فيديوهات بشخصيات متسقة بالاعتماد على المواد المرجعية',

        // التحكم في الأسلوب
        styleControlTitle: 'تحكم دقيق في الأسلوب',
        styleControlDescription: 'تحكّم في الطابع الفني باستخدام الصور المرجعية',

        // التحكم في الكاميرا
        cameraControlTitle: 'التحكم في الكاميرا',
        cameraControlDescription: 'ولّد فيديوهات بحركات كاميرا محددة',

        // الإطار الأول والأخير
        firstLastFrameTitle: 'الإطار الأول والأخير',
        firstLastFrameDescription: 'أنشئ فيديو سلسًا بين صورتين تم رفعهما',

        // كيفية الاستخدام
        howToUseTitle: 'طريقة الاستخدام',
        howToUseSubtitle: 'ابدأ بسرعة في ثلاث خطوات بسيطة',
        step1Title: 'اختر نموذج Veo 3 Fast',
        step1Description: 'انتقل إلى صفحة <span class="highlight-text">"توليد الفيديو بالذكاء الاصطناعي"</span> ثم اختر "Veo 3 Fast" من قائمة النماذج المنسدلة.',
        step2Title: 'أدخل فكرتك الإبداعية',
        step2Description: 'صف المحتوى الذي تريد توليده أو ارفع صورًا لتحويلها واستمتع بتجربة توليد سريعة.',
        step3Title: 'نزّل فيديوك بسرعة',
        step3Description: 'انقر على "إنشاء" لتحصل بسرعة على فيديوك عالي الجودة وتنزيله.',

        // فيديوهات YouTube
        youtubeTitle: 'فيديوهات YouTube حول نموذج Veo 3 Fast',
        youtubeVideosTitle: 'فيديوهات YouTube حول نموذج Veo 3 Fast',
        youtubeVideoTitle: 'فيديوهات YouTube حول نموذج Veo 3 Fast',

        // منشورات X
        xPostsTitle: 'منشورات X الشائعة حول Veo 3 Fast',

        // استكشاف نماذج أخرى
        exploreModelsTitle: 'استكشف نماذج Veo الأخرى',
        veoModelsTitle: 'نماذج Google Veo',
        veo2Title: 'مولّد الفيديو بالذكاء الاصطناعي Google Veo 2',
        veo31Title: 'مولّد الفيديو بالذكاء الاصطناعي Google Veo 3.1',
        veo3Title: 'مولّد الفيديو بالذكاء الاصطناعي Google Veo 3',

        // الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',

        // الدعوة إلى الإجراء
        ctaTitle: 'هل أنت مستعد للبدء في الإبداع؟',
        ctaSubtitle: 'جرّب Veo 3 Fast الآن واستمتع بتوليد فيديو سريع وعالي الجودة',
        ctaDescription: 'جرّب Veo 3 Fast الآن واستمتع بتوليد فيديو سريع وعالي الجودة',
        ctaButton: 'جرّب Veo 3 Fast على WeryAI',
        ctaNote: 'لا حاجة إلى بطاقة ائتمان',
        ctaDisclaimer: 'لا حاجة إلى بطاقة ائتمان',

        // تشغيل الفيديو
        videoNotSupported: 'المتصفح لديك لا يدعم تشغيل الفيديو',
        videoUnsupported: 'المتصفح لديك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // Page title and description
        pageTitle: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3 Fast - เร็วและคุณภาพสูง',
        pageDescription: 'สัมผัสเครื่องมือสร้างวิดีโอ AI Google Veo 3 Fast สำหรับการสร้างวิดีโอคุณภาพสูงอย่างรวดเร็ว พร้อมฟีเจอร์ข้อความเป็นวิดีโอและภาพเป็นวิดีโอ ลองฟรีบน WeryAI และสร้างวิดีโอ AI ระดับมืออาชีพได้ทันที',
        pageKeywords: 'Veo 3 Fast, เครื่องมือสร้างวิดีโอ AI ของ Google, วิดีโอ AI เร็ว, การสร้างวิดีโอ AI, เครื่องมือสร้างวิดีโอ, วิดีโอ AI ฟรี, WeryAI, การผลิตวิดีโอ',

        // Generator section
        generatorTitle: 'เครื่องมือสร้างวิดีโอ Google Veo 3 Fast',
        generatorDescription: 'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Veo 3 Fast อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Veo 3 Fast อย่างลึกซึ้งแล้ว Veo 3 Fast คือ <span class="highlight-red">เวอร์ชันที่เร็วกว่าและคุ้มค่ากว่า</span> ของเครื่องมือสร้างวิดีโอ Google Veo 3 สามารถสร้าง <span class="highlight-red">วิดีโอคุณภาพสูงสมจริง</span> พร้อม <span class="highlight-red">เสียงซิงก์อัตโนมัติ</span> ทั้งบทสนทนา เอฟเฟกต์เสียงแวดล้อม และดนตรี <span class="highlight-red">ลองใช้บนเครื่องมือสร้างวิดีโอ WeryAI ตอนนี้</span>!',
        
        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Veo 3 Fast',
        coreFeaturesSubtitle: 'สำรวจฟีเจอร์หลักของ Veo 3 Fast และสัมผัสการสร้างวิดีโอที่รวดเร็วและคุณภาพสูง',

        // Fast generation feature
        fastGenerationTitle: 'การสร้างวิดีโอเร็วสุดๆ',
        fastGenerationDescription: 'เร็วกว่า Veo 3 มาตรฐานประมาณ 30%',

        // Social media feature
        socialMediaTitle: 'เหมาะกับโซเชียลมีเดีย',
        socialMediaDescription: 'รองรับการสร้างคอนเทนต์สร้างสรรค์สำหรับแชร์บนโซเชียล เช่น "ข่าวปลอม" และ "การเดินทางข้ามเวลา"',

        // Immersive native audio feature
        immersiveAudioTitle: 'เสียงเนทีฟแบบเต็มอรรถรส',
        immersiveAudioDescription: 'สร้างเอฟเฟกต์เสียง บทสนทนา และเสียงแวดล้อมแบบอัตโนมัติ',

        // Video reference and consistent characters feature
        videoReferenceTitle: 'อ้างอิงวิดีโอและตัวละครคงที่',
        videoReferenceDescription: 'สร้างวิดีโอที่ตัวละครคงเอกลักษณ์จากวัสดุอ้างอิง',

        // Precise style control feature
        styleControlTitle: 'ควบคุมสไตล์อย่างแม่นยำ',
        styleControlDescription: 'ควบคุมสไตล์ศิลปะจากภาพอ้างอิง',

        // Camera control feature
        cameraControlTitle: 'ควบคุมกล้อง',
        cameraControlDescription: 'สร้างวิดีโอด้วยการเคลื่อนกล้องตามต้องการ',

        // First and last frame feature
        firstLastFrameTitle: 'เฟรมแรกและเฟรมสุดท้าย',
        firstLastFrameDescription: 'สร้างวิดีโอเชื่อมต่ออย่างลื่นไหลระหว่างสองภาพที่อัปโหลด',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: '3 ขั้นตอนง่าย ๆ เริ่มได้ทันที',
        step1Title: 'เลือกโมเดล Veo 3 Fast',
        step1Description: 'ไปที่หน้า <span class="highlight-text">"AI Video Generation"</span> แล้วคลิก "Veo 3 Fast" ในเมนูดรอปดาวน์ของโมเดล',
        step2Title: 'ป้อนคอนเทนต์สร้างสรรค์ของคุณ',
        step2Description: 'อธิบายเนื้อหาที่ต้องการสร้าง หรืออัปโหลดภาพเพื่อแปลง แล้วสัมผัสประสบการณ์การสร้างแบบเร็ว',
        step3Title: 'ดาวน์โหลดวิดีโออย่างรวดเร็ว',
        step3Description: 'คลิก "Create" เพื่อรับและดาวน์โหลดวิดีโอคุณภาพสูงที่สร้างขึ้นได้ทันที',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Veo 3 Fast',
        youtubeVideosTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Veo 3 Fast',
        youtubeVideoTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Veo 3 Fast',

        // X Posts section
        xPostsTitle: 'โพสต์ยอดนิยมบน X เกี่ยวกับ Veo 3 Fast',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดล Veo อื่น ๆ',
        veoModelsTitle: 'โมเดล Google Veo',
        veo2Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 2',
        veo31Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3.1',
        veo3Title: 'เครื่องมือสร้างวิดีโอ AI Google Veo 3',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',

        // CTA section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaSubtitle: 'ลอง Veo 3 Fast ตอนนี้และสัมผัสการสร้างวิดีโอที่รวดเร็วและคุณภาพสูง',
        ctaDescription: 'ลอง Veo 3 Fast ตอนนี้และสัมผัสการสร้างวิดีโอที่รวดเร็วและคุณภาพสูง',
        ctaButton: 'ลอง Veo 3 Fast บน WeryAI',
        ctaNote: 'ไม่ต้องใช้บัตรเครดิต',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',

        // Video playback related
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoUnsupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadingError: 'โหลดวิดีโอล้มเหลว',
        videoLoadError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // Page title and description
        pageTitle: 'Google Veo 3 Fast AI-videogenerator - hurtig værktøj til video i høj kvalitet',
        pageDescription: 'Oplev Google Veo 3 Fast AI-videogenerator til hurtig videogenerering i høj kvalitet med tekst-til-video og billede-til-video. Prøv gratis på WeryAI og skab professionelle AI-videoer hurtigt.',
        pageKeywords: 'Veo 3 Fast, Google AI-videogenerator, hurtig AI-video, AI-videoskabelse, videogenereringsværktøj, gratis AI-video, WeryAI, videoproduktion',

        // Generator section
        generatorTitle: 'Google Veo 3 Fast videogenerator',
        generatorDescription: 'WeryAI har nu integreret modellen Veo 3 Fast i dybden, Veo 3 Fast er en <span class="highlight-red">hurtigere og mere økonomisk version</span> af Google Veo 3-videogeneratoren. Den kan skabe <span class="highlight-red">højkvalitets, realistiske videoer</span> med <span class="highlight-red">synkroniseret lyd</span>, herunder dialog, ambient lydeffekter og musik. <span class="highlight-red">Prøv den på WeryAI-videogeneratoren nu</span>!',
        
        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Veo 3 Fast hovedfunktioner',
        coreFeaturesSubtitle: 'Udforsk kernefunktionerne i Veo 3 Fast og få en hurtig videoplevelse i høj kvalitet',

        // Fast generation feature
        fastGenerationTitle: 'Lynhurtig videogenerering',
        fastGenerationDescription: '30 % hurtigere end standard Veo 3',

        // Social media feature
        socialMediaTitle: 'Perfekt til sociale medier',
        socialMediaDescription: 'Understøtter kreativt indhold til deling på sociale platforme, såsom "fake news" og "tidsrejse"',

        // Immersive native audio feature
        immersiveAudioTitle: 'Omsluttende indbygget lyd',
        immersiveAudioDescription: 'Automatisk genererede lydeffekter, dialog og baggrundslyde',

        // Video reference and consistent characters feature
        videoReferenceTitle: 'Videoreference og konsistente karakterer',
        videoReferenceDescription: 'Generér videoer med ensartede karakterer ud fra referencemateriale',

        // Precise style control feature
        styleControlTitle: 'Præcis stilkontrol',
        styleControlDescription: 'Styr kunstnerisk stil baseret på referencebilleder',

        // Camera control feature
        cameraControlTitle: 'Kamerakontrol',
        cameraControlDescription: 'Generér videoer med specifikke kamerabevægelser',

        // First and last frame feature
        firstLastFrameTitle: 'Første og sidste frame',
        firstLastFrameDescription: 'Skab sømløse videoer mellem to uploadede billeder',

        // How to use section
        howToUseTitle: 'Sådan bruges det',
        howToUseSubtitle: 'Tre enkle trin til at komme hurtigt i gang',
        step1Title: 'Vælg Veo 3 Fast-model',
        step1Description: 'Gå til siden <span class="highlight-text">"AI Video Generation"</span>, og klik derefter "Veo 3 Fast" i modeldropdownen.',
        step2Title: 'Indtast dit kreative indhold',
        step2Description: 'Beskriv det indhold du vil generere, eller upload billeder til konvertering, og nyd den hurtige generering.',
        step3Title: 'Download din video hurtigt',
        step3Description: 'Klik "Create" for hurtigt at hente og downloade din genererede video i høj kvalitet.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Veo 3 Fast-videomodellen',
        youtubeVideosTitle: 'YouTube-videoer om Veo 3 Fast-videomodellen',
        youtubeVideoTitle: 'YouTube-videoer om Veo 3 Fast-videomodellen',

        // X Posts section
        xPostsTitle: 'Populære X-opslag om Veo 3 Fast',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre Veo-modeller',
        veoModelsTitle: 'Google Veo-modeller',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',

        // CTA section
        ctaTitle: 'Klar til at skabe?',
        ctaSubtitle: 'Prøv Veo 3 Fast nu og nyd hurtig videogenerering i høj kvalitet',
        ctaDescription: 'Prøv Veo 3 Fast nu og nyd hurtig videogenerering i høj kvalitet',
        ctaButton: 'Prøv Veo 3 Fast på WeryAI',
        ctaNote: 'Intet kreditkort kræves',
        ctaDisclaimer: 'Intet kreditkort kræves',

        // Video playback related
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoUnsupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadingError: 'Videoindlæsning mislykkedes',
        videoLoadError: 'Videoindlæsning mislykkedes',
        videoReload: 'Genindlæs',
        },
    no: {
        // Page title and description
        pageTitle: 'Google Veo 3 Fast AI-videogenerator - raskt verktøy for høy kvalitet',
        pageDescription: 'Opplev Google Veo 3 Fast AI-videogenerator for rask videoproduksjon i høy kvalitet med tekst-til-video og bilde-til-video. Prøv gratis på WeryAI og lag profesjonelle AI-videoer raskt.',
        pageKeywords: 'Veo 3 Fast, Google AI-videogenerator, rask AI-video, AI-videoskaping, videogenereringsverktøy, gratis AI-video, WeryAI, videoproduksjon',

        // Generator section
        generatorTitle: 'Google Veo 3 Fast videogenerator',
        generatorDescription: 'WeryAI har nå integrert modellen Veo 3 Fast i dybden, Veo 3 Fast er en <span class="highlight-red">raskere og mer økonomisk versjon</span> av Google Veo 3-videogeneratoren. Den kan lage <span class="highlight-red">høykvalitets, realistiske videoer</span> med <span class="highlight-red">synkronisert lyd</span>, inkludert dialog, ambient lydeffekter og musikk. <span class="highlight-red">Prøv den på WeryAI-videogeneratoren nå</span>!',
        
        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Veo 3 Fast hovedfunksjoner',
        coreFeaturesSubtitle: 'Utforsk kjernefunksjonene i Veo 3 Fast og få en rask videoproduksjon i høy kvalitet',

        // Fast generation feature
        fastGenerationTitle: 'Lynrask videogenerering',
        fastGenerationDescription: 'Omtrent 30 % raskere enn standard Veo 3',

        // Social media feature
        socialMediaTitle: 'Perfekt for sosiale medier',
        socialMediaDescription: 'Støtter kreativt innhold for deling på sosiale plattformer, som "fake news" og "tidsreise"',

        // Immersive native audio feature
        immersiveAudioTitle: 'Oppslukende innebygd lyd',
        immersiveAudioDescription: 'Automatisk genererte lydeffekter, dialog og bakgrunnslyd',

        // Video reference and consistent characters feature
        videoReferenceTitle: 'Videoreferanse og konsistente karakterer',
        videoReferenceDescription: 'Lag videoer med konsistente karakterer basert på referansemateriale',

        // Precise style control feature
        styleControlTitle: 'Presis stilkontroll',
        styleControlDescription: 'Styr kunstnerisk stil basert på referansebilder',

        // Camera control feature
        cameraControlTitle: 'Kamerakontroll',
        cameraControlDescription: 'Generer videoer med spesifikke kamerabevegelser',

        // First and last frame feature
        firstLastFrameTitle: 'Første og siste bilde',
        firstLastFrameDescription: 'Generer sømløse videoer mellom to opplastede bilder',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Tre enkle trinn for å komme raskt i gang',
        step1Title: 'Velg Veo 3 Fast-modell',
        step1Description: 'Gå til <span class="highlight-text">"AI Video Generation"</span>-siden og klikk "Veo 3 Fast" i modelldropdownen.',
        step2Title: 'Skriv inn ditt kreative innhold',
        step2Description: 'Beskriv innholdet du vil generere, eller last opp bilder for konvertering, og nyt den raske genereringen.',
        step3Title: 'Last ned videoen raskt',
        step3Description: 'Klikk "Create" for raskt å hente og laste ned den genererte videoen i høy kvalitet.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Veo 3 Fast-videomodellen',
        youtubeVideosTitle: 'YouTube-videoer om Veo 3 Fast-videomodellen',
        youtubeVideoTitle: 'YouTube-videoer om Veo 3 Fast-videomodellen',

        // X Posts section
        xPostsTitle: 'Populære X-innlegg om Veo 3 Fast',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre Veo-modeller',
        veoModelsTitle: 'Google Veo-modeller',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',

        // CTA section
        ctaTitle: 'Klar til å skape?',
        ctaSubtitle: 'Prøv Veo 3 Fast nå og nyt rask videogenerering i høy kvalitet',
        ctaDescription: 'Prøv Veo 3 Fast nå og nyt rask videogenerering i høy kvalitet',
        ctaButton: 'Prøv Veo 3 Fast på WeryAI',
        ctaNote: 'Ingen kredittkort nødvendig',
        ctaDisclaimer: 'Ingen kredittkort nødvendig',

        // Video playback related
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoUnsupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadingError: 'Videolasting mislyktes',
        videoLoadError: 'Videolasting mislyktes',
        videoReload: 'Last inn på nytt',
        },
    nl: {
        // Page title and description
        pageTitle: 'Google Veo 3 Fast AI-videogenerator - snelle AI-video van hoge kwaliteit',
        pageDescription: 'Ervaar de Google Veo 3 Fast AI-videogenerator voor snelle, hoogwaardige video\'s met tekst-naar-video en afbeelding-naar-video. Probeer gratis op WeryAI en maak snel professionele AI-video\'s.',
        pageKeywords: 'Veo 3 Fast, Google AI-videogenerator, snelle AI-video, AI-videocreatie, videogeneratie tool, gratis AI-video, WeryAI, videoproductie',

        // Generator section
        generatorTitle: 'Google Veo 3 Fast videogenerator',
        generatorDescription: 'WeryAI heeft het model Veo 3 Fast nu diep geïntegreerd, Veo 3 Fast is een <span class="highlight-red">snellere en voordeligere versie</span> van de Google Veo 3-videogenerator. Het kan <span class="highlight-red">realistische video\'s van hoge kwaliteit</span> maken met <span class="highlight-red">gesynchroniseerde audio</span>, inclusief dialoog, omgevingsgeluid en muziek. <span class="highlight-red">Probeer het nu op de WeryAI-videogenerator</span>!',
        
        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Belangrijkste functies van Veo 3 Fast',
        coreFeaturesSubtitle: 'Ontdek de kernfuncties van Veo 3 Fast en geniet van snelle videoproductie van hoge kwaliteit',

        // Fast generation feature
        fastGenerationTitle: 'Bliksemsnelle videogeneratie',
        fastGenerationDescription: 'Ongeveer 30% sneller dan standaard Veo 3',

        // Social media feature
        socialMediaTitle: 'Perfect voor social media',
        socialMediaDescription: 'Ondersteunt creatieve content voor delen op sociale platforms, zoals "fake news" en "tijdreizen"',

        // Immersive native audio feature
        immersiveAudioTitle: 'Meeslepende native audio',
        immersiveAudioDescription: 'Automatisch gegenereerde geluidseffecten, dialogen en omgevingsgeluiden',

        // Video reference and consistent characters feature
        videoReferenceTitle: 'Videoreferentie en consistente personages',
        videoReferenceDescription: 'Genereer video\'s met consistente personages op basis van referentiemateriaal',

        // Precise style control feature
        styleControlTitle: 'Precieze stijlcontrole',
        styleControlDescription: 'Stuur artistieke stijl op basis van referentiebeelden',

        // Camera control feature
        cameraControlTitle: 'Cameracontrole',
        cameraControlDescription: 'Genereer video\'s met specifieke camerabewegingen',

        // First and last frame feature
        firstLastFrameTitle: 'Eerste en laatste frame',
        firstLastFrameDescription: 'Genereer naadloze video\'s tussen twee geüploade afbeeldingen',

        // How to use section
        howToUseTitle: 'Zo gebruik je het',
        howToUseSubtitle: 'Drie eenvoudige stappen om snel te starten',
        step1Title: 'Selecteer het Veo 3 Fast-model',
        step1Description: 'Ga naar de <span class="highlight-text">"AI Video Generation"</span>-pagina en klik vervolgens op "Veo 3 Fast" in het modelkeuzemenu.',
        step2Title: 'Voer je creatieve content in',
        step2Description: 'Beschrijf de content die je wilt genereren of upload beelden voor conversie en geniet van de snelle generatie.',
        step3Title: 'Download je video snel',
        step3Description: 'Klik op "Create" om je gegenereerde video van hoge kwaliteit snel te verkrijgen en te downloaden.',

        // YouTube videos section
        youtubeTitle: 'YouTube-video\'s over het Veo 3 Fast-videomodel',
        youtubeVideosTitle: 'YouTube-video\'s over het Veo 3 Fast-videomodel',
        youtubeVideoTitle: 'YouTube-video\'s over het Veo 3 Fast-videomodel',

        // X Posts section
        xPostsTitle: 'Populaire X-berichten over Veo 3 Fast',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere Veo-modellen',
        veoModelsTitle: 'Google Veo-modellen',
        veo2Title: 'Google Veo 2 AI-videogenerator',
        veo31Title: 'Google Veo 3.1 AI-videogenerator',
        veo3Title: 'Google Veo 3 AI-videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',

        // CTA section
        ctaTitle: 'Klaar om te starten?',
        ctaSubtitle: 'Probeer Veo 3 Fast nu en geniet van snelle video\'s van hoge kwaliteit',
        ctaDescription: 'Probeer Veo 3 Fast nu en geniet van snelle video\'s van hoge kwaliteit',
        ctaButton: 'Probeer Veo 3 Fast op WeryAI',
        ctaNote: 'Geen creditcard vereist',
        ctaDisclaimer: 'Geen creditcard vereist',

        // Video playback related
        videoNotSupported: 'Je browser ondersteunt geen video-afspeling',
        videoUnsupported: 'Je browser ondersteunt geen video-afspeling',
        videoLoadingError: 'Video laden mislukt',
        videoLoadError: 'Video laden mislukt',
        videoReload: 'Opnieuw laden',
        },
    id: {
        // Page title and description
        pageTitle: 'Generator Video AI Google Veo 3 Fast - Alat Video AI Cepat Berkualitas Tinggi',
        pageDescription: 'Rasakan generator video AI Google Veo 3 Fast untuk pembuatan video cepat berkualitas tinggi dengan fitur teks-ke-video dan gambar-ke-video. Coba gratis di WeryAI dan buat video AI profesional dengan cepat.',
        pageKeywords: 'Veo 3 Fast, generator video AI Google, video AI cepat, pembuatan video AI, alat generasi video, video AI gratis, WeryAI, produksi video',

        // Generator section
        generatorTitle: 'Generator Video Google Veo 3 Fast',
        generatorDescription: 'WeryAI kini telah mengintegrasikan model Veo 3 Fast secara mendalam, Veo 3 Fast adalah <span class="highlight-red">versi yang lebih cepat dan lebih ekonomis</span> dari generator video Google Veo 3. Ia dapat membuat <span class="highlight-red">video berkualitas tinggi dan realistis</span> dengan <span class="highlight-red">audio tersinkron</span>, termasuk dialog, efek suara ambient, dan musik. <span class="highlight-red">Coba sekarang di generator video WeryAI</span>!',
        
        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Utama Veo 3 Fast',
        coreFeaturesSubtitle: 'Jelajahi fitur inti Veo 3 Fast dan nikmati pengalaman pembuatan video cepat berkualitas tinggi',

        // Fast generation feature
        fastGenerationTitle: 'Generasi Video Super Cepat',
        fastGenerationDescription: 'Sekitar 30% lebih cepat daripada Veo 3 standar',

        // Social media feature
        socialMediaTitle: 'Sempurna untuk Media Sosial',
        socialMediaDescription: 'Mendukung pembuatan konten kreatif untuk dibagikan di platform sosial, seperti "fake news" dan "time travel"',

        // Immersive native audio feature
        immersiveAudioTitle: 'Audio Native yang Imersif',
        immersiveAudioDescription: 'Efek suara, dialog, dan suara ambient dihasilkan otomatis',

        // Video reference and consistent characters feature
        videoReferenceTitle: 'Referensi Video dan Karakter Konsisten',
        videoReferenceDescription: 'Hasilkan video dengan karakter konsisten berdasarkan materi referensi',

        // Precise style control feature
        styleControlTitle: 'Kontrol Gaya Presisi',
        styleControlDescription: 'Kendalikan gaya artistik berdasarkan gambar referensi',

        // Camera control feature
        cameraControlTitle: 'Kontrol Kamera',
        cameraControlDescription: 'Hasilkan video dengan pergerakan kamera tertentu',

        // First and last frame feature
        firstLastFrameTitle: 'Frame Pertama dan Terakhir',
        firstLastFrameDescription: 'Hasilkan video mulus di antara dua gambar yang diunggah',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana untuk mulai dengan cepat',
        step1Title: 'Pilih Model Veo 3 Fast',
        step1Description: 'Masuk ke halaman <span class="highlight-text">"AI Video Generation"</span>, lalu klik "Veo 3 Fast" di menu dropdown model.',
        step2Title: 'Masukkan Konten Kreatif Anda',
        step2Description: 'Jelaskan konten yang ingin dibuat, atau unggah gambar untuk konversi, dan nikmati pengalaman generasi yang cepat.',
        step3Title: 'Unduh Video Anda dengan Cepat',
        step3Description: 'Klik "Create" untuk segera memperoleh dan mengunduh video berkualitas tinggi yang dihasilkan.',

        // YouTube videos section
        youtubeTitle: 'Video YouTube tentang Model Video Veo 3 Fast',
        youtubeVideosTitle: 'Video YouTube tentang Model Video Veo 3 Fast',
        youtubeVideoTitle: 'Video YouTube tentang Model Video Veo 3 Fast',

        // X Posts section
        xPostsTitle: 'Posting X Populer tentang Veo 3 Fast',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi Model Veo Lain',
        veoModelsTitle: 'Model Google Veo',
        veo2Title: 'Generator Video AI Google Veo 2',
        veo31Title: 'Generator Video AI Google Veo 3.1',
        veo3Title: 'Generator Video AI Google Veo 3',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',

        // CTA section
        ctaTitle: 'Siap mulai berkarya?',
        ctaSubtitle: 'Coba Veo 3 Fast sekarang dan nikmati generasi video cepat berkualitas tinggi',
        ctaDescription: 'Coba Veo 3 Fast sekarang dan nikmati generasi video cepat berkualitas tinggi',
        ctaButton: 'Coba Veo 3 Fast di WeryAI',
        ctaNote: 'Tidak perlu kartu kredit',
        ctaDisclaimer: 'Tidak perlu kartu kredit',

        // Video playback related
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoUnsupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadingError: 'Gagal memuat video',
        videoLoadError: 'Gagal memuat video',
        videoReload: 'Muat ulang',
        },
    tr: {
        // Page title and description
        pageTitle: 'Google Veo 3 Fast AI Video Üretici - Hızlı ve Yüksek Kaliteli AI Video Aracı',
        pageDescription: 'Google Veo 3 Fast AI video üreticisiyle metinden videoya ve görselden videoya özellikleriyle hızlı, yüksek kaliteli video üretin. WeryAI’de ücretsiz deneyin ve profesyonel AI videolarını hızlıca oluşturun.',
        pageKeywords: 'Veo 3 Fast, Google AI video üretici, hızlı AI video, AI video oluşturma, video üretim aracı, ücretsiz AI video, WeryAI, video prodüksiyon',

        // Generator section
        generatorTitle: 'Google Veo 3 Fast Video Üretici',
        generatorDescription: 'WeryAI artık Veo 3 Fast modelini derinlemesine entegre ediyor, Veo 3 Fast, Google Veo 3 video üreticisinin <span class="highlight-red">daha hızlı ve daha ekonomik bir sürümüdür</span>. Diyalog, ortam sesleri ve müzik dahil <span class="highlight-red">senkronize ses</span> ile <span class="highlight-red">yüksek kaliteli, gerçekçi videolar</span> üretebilir. <span class="highlight-red">WeryAI video üreticide hemen deneyin</span>!',
        
        // Tabs
        tabImageToVideo: 'Görselden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Veo 3 Fast Temel Özellikler',
        coreFeaturesSubtitle: 'Veo 3 Fast’in temel özelliklerini keşfedin ve hızlı, yüksek kaliteli video üretiminin keyfini çıkarın',

        // Fast generation feature
        fastGenerationTitle: 'Yıldırım Hızında Video Üretimi',
        fastGenerationDescription: 'Standart Veo 3’ten %30 daha hızlı',

        // Social media feature
        socialMediaTitle: 'Sosyal Medya için Mükemmel',
        socialMediaDescription: '“Sahte haber” ve “zaman yolculuğu” gibi sosyal platformlarda paylaşılacak yaratıcı içerik üretimini destekler',

        // Immersive native audio feature
        immersiveAudioTitle: 'Sürükleyici Yerleşik Ses',
        immersiveAudioDescription: 'Otomatik üretilen ses efektleri, diyalog ve ortam sesleri',

        // Video reference and consistent characters feature
        videoReferenceTitle: 'Video Referansı ve Tutarlı Karakterler',
        videoReferenceDescription: 'Referans materyallere göre karakter tutarlılığı olan videolar üretin',

        // Precise style control feature
        styleControlTitle: 'Hassas Stil Kontrolü',
        styleControlDescription: 'Referans görsellere göre sanatsal stili kontrol edin',

        // Camera control feature
        cameraControlTitle: 'Kamera Kontrolü',
        cameraControlDescription: 'Belirli kamera hareketleriyle video üretin',

        // First and last frame feature
        firstLastFrameTitle: 'İlk Kare ve Son Kare',
        firstLastFrameDescription: 'Yüklenen iki görsel arasında kesintisiz video üretin',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Hızlı başlamak için üç basit adım',
        step1Title: 'Veo 3 Fast Modelini Seçin',
        step1Description: '<span class="highlight-text">"AI Video Generation"</span> sayfasına gidin, ardından model açılır menüsünden "Veo 3 Fast"i seçin.',
        step2Title: 'Yaratıcı İçeriğinizi Girin',
        step2Description: 'Üretmek istediğiniz içeriği açıklayın veya dönüşüm için görsel yükleyin ve hızlı üretim deneyiminin keyfini çıkarın.',
        step3Title: 'Videonuzu Hızla İndirin',
        step3Description: '“Create”a tıklayarak üretilen yüksek kaliteli videoyu hızlıca alın ve indirin.',

        // YouTube videos section
        youtubeTitle: 'Veo 3 Fast Video Modeli Hakkında YouTube Videoları',
        youtubeVideosTitle: 'Veo 3 Fast Video Modeli Hakkında YouTube Videoları',
        youtubeVideoTitle: 'Veo 3 Fast Video Modeli Hakkında YouTube Videoları',

        // X Posts section
        xPostsTitle: 'Veo 3 Fast Hakkında Popüler X Paylaşımları',

        // Explore other models section
        exploreModelsTitle: 'Diğer Veo Modellerini Keşfedin',
        veoModelsTitle: 'Google Veo Modelleri',
        veo2Title: 'Google Veo 2 AI Video Üretici',
        veo31Title: 'Google Veo 3.1 AI Video Üretici',
        veo3Title: 'Google Veo 3 AI Video Üretici',

        // FAQ section
        faqTitle: 'Sıkça Sorulan Sorular',

        // CTA section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaSubtitle: 'Veo 3 Fast’i şimdi deneyin ve hızlı, yüksek kaliteli video üretiminin keyfini çıkarın',
        ctaDescription: 'Veo 3 Fast’i şimdi deneyin ve hızlı, yüksek kaliteli video üretiminin keyfini çıkarın',
        ctaButton: 'WeryAI’de Veo 3 Fast’i deneyin',
        ctaNote: 'Kredi kartı gerekmez',
        ctaDisclaimer: 'Kredi kartı gerekmez',

        // Video playback related
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoUnsupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadingError: 'Video yükleme başarısız',
        videoLoadError: 'Video yükleme başarısız',
        videoReload: 'Yeniden yükle',
    },
}
